import React from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { ICustomHeaderProps } from 'app/types';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { Icon } from '../Icon/Icon';
import { colorPalette } from '@shared/config/colorsConfig';
import Button from '../Button/Button';

export const BackStackNavHeader: React.FC<ICustomHeaderProps> = ({
    style = {},
    customNavigation
}) => {
    const { t } = useTranslation();
    const navigation = useNavigation();

    let insets;
    try {
        insets = useSafeAreaInsets();
    } catch (error) {
        console.warn('SafeAreaInsets not available, using fallback:', error);
        insets = { top: 0, bottom: 0, left: 0, right: 0 };
    }

    return (
        <View
            className="px-8 pb-6"
            style={{ paddingTop: insets.top + 20, ...style }}
        >
            <Button variant="link" onPress={() => customNavigation ? customNavigation() : navigation.goBack()} icon="arrow-left" customIcon={
                <View className='w-8 h-8 rounded-full border border-gray-300 justify-center items-center'>
                    <Icon name="arrow-left" size={16} color={colorPalette.primary[700]} />
                </View>
            }>
                {t('buttons.back')}
            </Button>
        </View>
    );
};

BackStackNavHeader.displayName = 'BackStackNavHeader';
